import get from 'lodash/get';

export const Session = data => ({
  id: data.id,
  name: data.name,
  preview: data.preview,
  createdAt: data.createdAt ? Date.parse(data.createdAt) : null,
  lastSeenAt: data.lastSeenAt ? Date.parse(data.lastSeenAt) : null,
  lastMessageAt: data.lastMessageAt ? Date.parse(data.lastMessageAt) : null,
  trackingId: data.trackingId,
  lockedAt: data.lockedAt,
  lockReason: data.lockReason,
  satisfactionId: data.satisfactionId,
  satisfactionStatus: data.satisfactionStatus,
  satisfactionLockedAt: data.satisfactionLockedAt,
  satisfactionSubmittedAt: data.satisfactionSubmittedAt,
});

export const responseDataToSession = responseData => {
  return new Session({
    id: responseData.id,
    name: responseData.attributes.name,
    preview: responseData.attributes.preview,
    createdAt: responseData.attributes.createdAt,
    lastSeenAt: responseData.attributes.lastSeenAt,
    lastMessageAt: responseData.attributes.lastMessageAt,
    trackingId: responseData.attributes.trackingId,
    lockedAt: responseData.attributes.lockedAt,
    lockReason: responseData.attributes.lockReason,
    satisfactionId: get(responseData, 'attributes.satisfaction.id'),
    satisfactionStatus: get(responseData, 'attributes.satisfaction.status'),
    satisfactionLockedAt: get(responseData, 'attributes.satisfaction.lockedAt'),
    satisfactionSubmittedAt: get(responseData, 'attributes.satisfaction.submittedAt'),
  });
};

export const responseToSession = response => {
  return responseDataToSession(response.data.data);
};

export const responseToSessionList = response => {
  return response.data.data.map(responseDataToSession);
};
